import React from 'react';
import ProfileEditView from './ProfileEditView';
import useProfileEdit from './ProfileEditLogic';

const ProfileEdit = ({ userData, onClose, onSuccess }) => {
  const {
    displayName,
    setDisplayName,
    phoneNumber,
    setPhoneNumber,
    isPhoneVerified,
    setIsPhoneVerified,
    showPhoneVerification,
    verificationCode,
    setVerificationCode,
    loading,
    error,
    successMessage,
    phoneError,
    verificationError,
    isSendingCode,
    isVerifying,
    handleSendVerificationCode,
    handleVerifyCode,
    handleSubmit,
    resetVerification
  } = useProfileEdit(userData, onClose, onSuccess);

  return (
    <ProfileEditView
      displayName={displayName}
      setDisplayName={setDisplayName}
      phoneNumber={phoneNumber}
      setPhoneNumber={setPhoneNumber}
      isPhoneVerified={isPhoneVerified}
      setIsPhoneVerified={setIsPhoneVerified}
      showPhoneVerification={showPhoneVerification}
      verificationCode={verificationCode}
      setVerificationCode={setVerificationCode}
      loading={loading}
      error={error}
      successMessage={successMessage}
      phoneError={phoneError}
      verificationError={verificationError}
      isSendingCode={isSendingCode}
      isVerifying={isVerifying}
      handleSendVerificationCode={handleSendVerificationCode}
      handleVerifyCode={handleVerifyCode}
      handleSubmit={handleSubmit}
      resetVerification={resetVerification}
      onClose={onClose}
    />
  );
};

export default ProfileEdit; 